module.exports = __webpack_public_path__ + "static/media/mode1.811f5157.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode1.gif
// module id = 1327
// module chunks = 114